// eslint-disable-next-line import/no-extraneous-dependencies
import axios from "axios";

const URL_BASE = `${process.env.ROOT_API}/auth`;
export default class AuthService{
	static async login(form) {
		return axios.post(`${URL_BASE}/login`, form);
	}
	static cadastrarUsuario(form, idUsuarioResponsavel) {
		return axios.post(`${URL_BASE}/cadastrar?idUsuarioResponsavel=${idUsuarioResponsavel}`, form);
	}
	static atualizarUsuario(form, id, idUsuarioResponsavel) {
		return axios.put(`${URL_BASE}/atualizar/` + id + `?idUsuarioResponsavel=${idUsuarioResponsavel}`, form);
	}
	static alterarSenha(id, form, idUsuarioResponsavel) {
		return axios.put(`${URL_BASE}/alterarSenha/` + id + `?idUsuarioResponsavel=${idUsuarioResponsavel}`, form);
	}
	static excluirUsuario(id, idUsuarioResponsavel) {
		return axios.delete(`${URL_BASE}/deletar/` + id + `?idUsuarioResponsavel=${idUsuarioResponsavel}`);
	}
	static atualizarDadosPessoais(form, idUsuarioResponsavel) {
		return axios.put(`${URL_BASE}/atualizarDadosPessoais?idUsuarioResponsavel=${idUsuarioResponsavel}`, form);
	}
	static enviarFormularioEsqueciMinhaSenha(form) {
		return axios.post(`${URL_BASE}/esqueciMinhaSenha`, form);
	}
	static redefinirSenhaViaEsqueciMinhaSenha(form) {
		return axios.put(`${URL_BASE}/redefinirSenhaViaEsqueciMinhaSenha`, form);
	}
}



// WEBPACK FOOTER //
// ./src/service/AuthService.js